import apiClient from './api';
import { EntryTypeDto, EntryTypeSummaryDto } from '../types/entryTypes.types';

class EntryTypesService {
  private baseUrl = '/EntryTypes';

  // Get all entry types
  async getAll(includeInactive?: boolean): Promise<EntryTypeDto[]> {
    const params = new URLSearchParams();
    if (includeInactive !== undefined) {
      params.append('includeInactive', includeInactive.toString());
    }

    const url = params.toString() ? `${this.baseUrl}?${params.toString()}` : this.baseUrl;
    const response = await apiClient.get(url);
    return response.data;
  }

  // Get entry type by ID
  async getById(id: number): Promise<EntryTypeDto> {
    const response = await apiClient.get(`${this.baseUrl}/${id}`);
    return response.data;
  }

  // Get entry type by code
  async getByCode(code: string): Promise<EntryTypeDto> {
    const response = await apiClient.get(`${this.baseUrl}/code/${code}`);
    return response.data;
  }

  // Get manual entry types only
  async getManualEntryTypes(includeInactive?: boolean): Promise<EntryTypeDto[]> {
    const params = new URLSearchParams();
    if (includeInactive !== undefined) {
      params.append('includeInactive', includeInactive.toString());
    }

    const url = params.toString() 
      ? `${this.baseUrl}/manual?${params.toString()}` 
      : `${this.baseUrl}/manual`;
    const response = await apiClient.get(url);
    return response.data;
  }
}

export const entryTypesService = new EntryTypesService();